import { type MouseEvent, useCallback } from 'react';

import { type Bet } from '~/apps/product-plus/components/BettingInsights/types';
import { useRepubContext } from '~/providers/repub-context.tsx';

export const useClickoutBet = ({
  bet,
  onClick,
}: {
  bet: Bet;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}) => {
  const { repub } = useRepubContext();

  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      const clickoutUrl = `/api/cx/clickout?repub=${repub}&betId=${bet.betId}&bookmakerCode=${bet.bookmakerCode}`;

      window.open(clickoutUrl, '_blank');

      onClick?.(e);
    },
    [repub, bet.betId, bet.bookmakerCode, onClick],
  );

  // Clickout repubs have no betslip concept - always return false
  return { handleClick, isBetInBetslip: false };
};
